
import React, { useEffect, useState } from "react";
import {
  Card,
  Collapse,
  Spin,
  Typography,
  Empty,
  Tabs,
  Badge,
  Row,
  Col,
  Tag,
  Modal,
  Form,
  Button,
  DatePicker,
  Input,
  message,
} from "antd";
import {
  ProjectOutlined,
  TeamOutlined,
  CalendarOutlined,
  FlagOutlined,
  FireOutlined,
} from "@ant-design/icons";

import TaskCard from "./TaskCard";
import ByDeadline from "./ByDeadline";
import { UserService } from "../../Services/Manage/UserService";
import ViewHistory from "./ViewHistory";
import TaskService from "../../Services/Manage/TaskService";
import { ProjectService } from "../../Services/Manage/ProjectService";

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const { Panel } = Collapse;
const { Text } = Typography;
const { TabPane } = Tabs;
const { TextArea } = Input;

const safeParseJSON = (str, fallback = []) => {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
};

const statusColors = {
  "To Do": "#1890ff",
  "In Progress": "#52c41a",
  Done: "#13c2c2",
  "On Hold": "#faad14",
  Archived: "#ff4d4f",
};

function AssignedTask() {
  const perm = getPermission('/assigned-task');
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);


  const [viewHistoryOpen, setViewHistoryOpen] = useState(false);
  const [selectedHistoryTask, setSelectedHistoryTask] = useState(null);
  const [reloadHistory, setReloadHistory] = useState(false);


  const [doneModalOpen, setDoneModalOpen] = useState(false);
  const [inProgressModalOpen, setInProgressModalOpen] = useState(false);
  const [onHoldModalOpen, setOnHoldModalOpen] = useState(false);
  const [commentModalOpen, setCommentModalOpen] = useState(false);

  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedInProgressTask, setSelectedInProgressTask] = useState(null);
  const [selectedOnHoldTask, setSelectedOnHoldTask] = useState(null);
  const [selectedCommentTask, setSelectedCommentTask] = useState(null);

  const [doneForm] = Form.useForm();
  const [inProgressForm] = Form.useForm();
  const [onHoldForm] = Form.useForm();
  const [commentForm] = Form.useForm();
  const [departments, setDepartments] = useState({});
  const [employeeMap, setEmployeeMap] = useState({});
  useEffect(() => {
    const loadData = async () => {
      await fetchEmployees();
      await fetchAssignedTasks();
    };
    loadData();
  }, []);


  const fetchEmployees = async () => {
    try {
      const resp = await UserService.getAllUsers();
      const map = {};
      resp.data.forEach(user => {
        map[user.user_id] = user.name;
      });
      setEmployeeMap(map);
      return map;
    } catch (err) {
      console.error("Error fetching employees:", err);
      return {};
    }
  };

  const fetchDepartments = async () => {
    try {
      const projectResp = await ProjectService.getAllProject();

      const depMap = {};
      projectResp.data.forEach(p => {

        depMap[p.pro_department] = p.department_name;
      });
      setDepartments(depMap);
      return depMap;
    } catch (err) {
      console.error("Error fetching projects:", err);
      return {};
    }
  };


  const fetchAssignedTasks = async () => {
    setLoading(true);
    try {
      const user = await UserService.getOmeUser();
      const userId = user?.uid;

      if (!userId) {
        setProjects([]);
        return;
      }

      const depMap = await fetchDepartments();
      const empMap = await fetchEmployees();
      const resp = await TaskService.getAssignedTasks(userId);
      let taskProjects = resp?.status ? resp.data : [];

      taskProjects = taskProjects.map(p => ({
        ...p,
        dep_name: depMap[p.pro_department] || "N/A",
        assigned_tasks: p.assigned_tasks.map(t => {
          const employeeNames = safeParseJSON(t.assigned_employee || "[]")
            .map(id => empMap[id] || id);

          return {
            ...t,
            employeeNames,
            comment: t.comment || t.pro_comment || ""
          };
        })
      }));


      setProjects(taskProjects);


    } catch (err) {
      console.error("Error fetching tasks:", err);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };


  const openHistoryModal = (task) => {
    const mappedTask = {
      key: task.id,
      task: task.task_name,
      description: task.task_description,
      priority: task.priority,
      status: task.status,
      employees: (task.employeeNames || safeParseJSON(task.assigned_employee || "[]")),
      dueDate: task.due_date ? new Date(task.due_date).toLocaleDateString() : "",
      urgency: task.urgency,
      comment: "",
    };
    setSelectedHistoryTask(mappedTask);
    setReloadHistory(prev => !prev);
    setViewHistoryOpen(true);
  };


  const closeHistoryModal = () => setViewHistoryOpen(false);

const openDoneModal = (task) => {
    if (!perm.edit) { message.warning("You don't have permission to edit"); return; }
    setSelectedTask(task);
    setTimeout(() => {
      doneForm.resetFields();
      doneForm.setFieldsValue({
        completionDate: null,
        note: "",
      });
    }, 0);
    setDoneModalOpen(true);
  };

const openInProgressModal = (task) => {
    if (!perm.edit) { message.warning("You don't have permission to edit"); return; }
    setSelectedInProgressTask(task);
    setTimeout(() => {
      inProgressForm.resetFields();
      inProgressForm.setFieldsValue({ note: "" });
    }, 0);
    setInProgressModalOpen(true);
  };

const openOnHoldModal = (task) => {
    if (!perm.edit) { message.warning("You don't have permission to edit"); return; }
    setSelectedOnHoldTask(task);
    setTimeout(() => {
      onHoldForm.resetFields();
      onHoldForm.setFieldsValue({
        reason: "",
        note: "",
      });
    }, 0);
    setOnHoldModalOpen(true);
  };

const openCommentModal = (task) => {
    if (!perm.edit) { message.warning("You don't have permission to edit"); return; }
    setSelectedCommentTask(task);
    setTimeout(() => {
      commentForm.resetFields();
      commentForm.setFieldsValue({ comment: "" });
    }, 0);
    setCommentModalOpen(true);
  };


const handleStatusChange = async (taskId, newStatus, extra = {}) => {
    if (!perm.edit) { message.warning("You don't have permission to edit"); return; }
    if (!taskId) return;
    const timelinePayload = {
      task_id: String(taskId),
      status: newStatus,
      completion_date: extra.completion_date
        ? (extra.completion_date.format ? extra.completion_date.format("YYYY-MM-DD") : extra.completion_date)
        : null,
      note: extra.note || "",
      comment: extra.comment || "",
    };

    const updatePayload = { status: newStatus };

    try {
      await TaskService.createTimeLine(timelinePayload);
      await TaskService.updateTask(updatePayload, taskId);

      setProjects(prev =>
        prev.map(project => ({
          ...project,
          assigned_tasks: project.assigned_tasks.map(t =>
            t.id === taskId
              ? {
                ...t,
                status: newStatus,
                note: extra.note !== undefined ? extra.note : t.note,

              }
              : t
          ),
        }))
      );

      if (selectedHistoryTask?.key === taskId) setReloadHistory(prev => !prev);

      message.success(`Task updated to "${newStatus}"`);
    } catch (err) {
      console.error("Error updating task or timeline:", err);
      message.error("Failed to update task. Please try again.");
    }
  };


  const handleDoneSubmit = async (values) => {
    if (!selectedTask) return;
    await handleStatusChange(selectedTask.id, "Done", { completion_date: values.completionDate, note: values.note });
    setDoneModalOpen(false);
  };

  const handleInProgressSubmit = async (values) => {
    if (!selectedInProgressTask) return;
    await handleStatusChange(selectedInProgressTask.id, "In Progress", { note: values.note });
    setInProgressModalOpen(false);
  };

  const handleOnHoldSubmit = async (values) => {
    if (!selectedOnHoldTask) return;

    await handleStatusChange(selectedOnHoldTask.id, "On Hold", { note: values.note, comment: values.reason });
    setOnHoldModalOpen(false);
  };

  const handleCommentSubmit = async (values) => {
    if (!selectedCommentTask) return;

    try {
      const payload = {
        task_name: selectedCommentTask.task_name,
        task_description: selectedCommentTask.task_description,
        priority: selectedCommentTask.priority,
        status: selectedCommentTask.status,
        assigned_employee: JSON.stringify(selectedCommentTask.assigned_employee || []),
        due_date: selectedCommentTask.due_date,
        urgency: selectedCommentTask.urgency,
        pro_department: selectedCommentTask.pro_department,
        comment: values.comment,
      };

      await TaskService.updateTask(payload, selectedCommentTask.id);

      setProjects(prev =>
        prev.map(project => ({
          ...project,
          assigned_tasks: project.assigned_tasks.map(t =>
            t.id === selectedCommentTask.id ? { ...t, comment: values.comment } : t
          ),
        }))
      );

      setCommentModalOpen(false);
      message.success("Comment added to task card");
    } catch (err) {
      console.error("Error updating comment:", err);
      message.error("Failed to add comment");
    }
  };






  const renderTabs = (activeTasks) => {
    const statuses = ["To Do", "In Progress", "On Hold", "Done"];
    const tasksByStatus = {};
    statuses.forEach(st => tasksByStatus[st] = activeTasks.filter(t => t.status === st));
    const otherTasks = activeTasks.filter(t => !statuses.includes(t.status));
    if (otherTasks.length > 0) tasksByStatus["Others"] = otherTasks;

    const renderTaskList = (list) =>
      list.length > 0 ? list.map(task => (
        <TaskCard
          key={task.id}
          task={{
            key: task.id,
            task: task.task_name,
            description: task.task_description,
            priority: task.priority,
            status: task.status,
            employees: task.employeeNames || [],


            dueDate: task.due_date ? new Date(task.due_date).toLocaleDateString() : "",
            urgency: task.urgency,
            comment: task.comment || task.pro_comment || "",


          }}
          onViewHistory={() => openHistoryModal(task)}
          onMarkAsDone={() => openDoneModal(task)}
          onMarkInProgress={() => openInProgressModal(task)}
          onPutOnHold={() => openOnHoldModal(task)}
          onAddComment={() => openCommentModal(task)}
          onArchive={(task) => handleStatusChange(task.key, "Archived", { comment: "Archived" })}
        />
      )) : <Empty description="No tasks" />;

    return (
      <div style={{ display: "flex", gap: 16, justifyContent: "space-around", flexWrap: "wrap", padding: "16px 0" }}>
        {statuses.map(st => (
          <div key={st} style={{ flex: 1, minWidth: 250 }}>
            <Card
              title={<span style={{ fontWeight: "bold" }}>{st} <Badge count={tasksByStatus[st]?.length || 0} style={{ backgroundColor: statusColors[st] }} /></span>}
              style={{ backgroundColor: "#f9f9f9", border: "1px solid #e0e0e0", borderRadius: 10, height: "100%" }}
              bodyStyle={{ maxHeight: 500, overflowY: "auto", padding: 12 }}
            >
              {renderTaskList(tasksByStatus[st])}
            </Card>
          </div>
        ))}
        {tasksByStatus["Others"] && tasksByStatus["Others"].length > 0 && (
          <div key="Others" style={{ flex: 1, minWidth: 250 }}>
            <Card title={<span style={{ fontWeight: "bold" }}>Others <Badge count={tasksByStatus["Others"].length} style={{ backgroundColor: "#722ed1" }} /></span>}
              style={{ backgroundColor: "#f9f9f9", border: "1px solid #e0e0e0", borderRadius: 10 }}
              bodyStyle={{ maxHeight: 500, overflowY: "auto", padding: 12 }}
            >
              {renderTaskList(tasksByStatus["Others"])}
            </Card>
          </div>
        )}
      </div>
    );
  };

  const renderInfoCard = (icon, label, value) => (
    <Card size="small" variant="borderless" style={{ borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>{icon}<Text strong style={{ marginLeft: 8 }}>{label}</Text></div>
      <Text>{value}</Text>
    </Card>
  );

  return (
    <div>
      <Card title="Assigned Tasks" variant="borderless">
        {loading ? <Spin /> : projects.length > 0 ? projects.map(project => {
          const tasks = project.assigned_tasks || [];
          const activeTasks = tasks.filter(t => t.status !== "Archived");
          const archivedTasks = tasks.filter(t => t.status === "Archived");
          const sortedTasks = [...activeTasks].sort((a, b) => new Date(a.due_date) - new Date(b.due_date));

          return (
            <Card key={project.id} style={{ marginBottom: 24 }}
              title={<span><ProjectOutlined style={{ marginRight: 8, color: "#1890ff" }} /><Text strong style={{ fontSize: 16 }}>{project.pro_name}</Text></span>}
              headStyle={{ background: "#f5f5f5" }}
            >
              <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} sm={12} md={8} lg={6}>{renderInfoCard(<TeamOutlined style={{ color: "#722ed1" }} />, "Department", project.dep_name || "N/A")}</Col>
                <Col xs={24} sm={12} md={8} lg={6}>{renderInfoCard(<CalendarOutlined style={{ color: "#13c2c2" }} />, "Start Date", project.pro_start_date ? new Date(project.pro_start_date).toLocaleDateString() : "N/A")}</Col>
                <Col xs={24} sm={12} md={8} lg={6}>{renderInfoCard(<FlagOutlined style={{ color: "#fa8c16" }} />, "Target End Date", project.pro_target_end_date ? new Date(project.pro_target_end_date).toLocaleDateString() : "N/A")}</Col>
                <Col xs={24} sm={12} md={8} lg={6}>{renderInfoCard(<FireOutlined style={{ color: "#ff4d4f" }} />, "Status", <Tag color="processing">{project.pro_status}</Tag>)}</Col>
              </Row>
              <Collapse >
                <Panel header="Assigned Tasks" key="1">
                  <Tabs defaultActiveKey="1">
                    <TabPane key="1" tab={<span>Task Tracker <Badge count={activeTasks.length} style={{ backgroundColor: "#1890ff" }} /></span>}>
                      {renderTabs(activeTasks)}
                    </TabPane>
                    <TabPane key="2" tab={<span>By Deadline</span>}>
                      <ByDeadline data={sortedTasks.map(task => ({
                        key: task.id,
                        task: task.task_name,
                        description: task.task_description,
                        priority: task.priority,
                        status: task.status,
                        employees: (task.employeeNames || []).join(", "),


                        dueDate: task.due_date ? new Date(task.due_date).toLocaleDateString() : "",
                        urgency: task.urgency
                      }))} />
                    </TabPane>
                    <TabPane
                      tab={<span>Archived Tasks <Badge count={archivedTasks.length} style={{ backgroundColor: statusColors["Archived"] }} /></span>}
                      key="3"
                    >
                      {archivedTasks.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No archived tasks" /> :
                        archivedTasks.map(t => (
                          <TaskCard
                            key={t.id}
                            task={{
                              key: t.id,
                              task: t.task_name,
                              description: t.task_description,
                              priority: t.priority,
                              status: t.status,
                              employees: safeParseJSON(t.assigned_employee || "[]"),
                              dueDate: t.due_date ? new Date(t.due_date).toLocaleDateString() : "",
                              urgency: t.urgency,
                              comment: t.status === "On Hold" ? "" : t.comment || t.pro_comment || "",
                            }}
                            onMarkAsDone={() => openDoneModal(t)}
                            onMarkInProgress={() => openInProgressModal(t)}
                            onPutOnHold={() => openOnHoldModal(t)}
                            onAddComment={() => openCommentModal(t)}
                            onViewHistory={() => openHistoryModal(t)}
                            onArchive={() => handleStatusChange(t.id, "Archived", { comment: "Archived" })}
                          />
                        ))
                      }
                    </TabPane>
                  </Tabs>
                </Panel>
              </Collapse>
            </Card>
          );
        }) : <Empty description="No assigned tasks" />}
      </Card>


      <Modal open={viewHistoryOpen} onCancel={closeHistoryModal} footer={null} width={600}>
        {selectedHistoryTask && <ViewHistory task={selectedHistoryTask} reloadTrigger={reloadHistory} />}
      </Modal>


      <Modal title={`Mark Task as Done: ${selectedTask?.task_name}`} open={doneModalOpen} footer={null} onCancel={() => setDoneModalOpen(false)}>
        <Form form={doneForm} layout="vertical" onFinish={handleDoneSubmit}>
          <Form.Item name="completionDate" label="Completion Date" rules={[{ required: true }]}>
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="note" label="Note">
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>Mark as Done</Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal title={`Mark Task In Progress: ${selectedInProgressTask?.task_name}`} open={inProgressModalOpen} footer={null} onCancel={() => setInProgressModalOpen(false)}>
        <Form form={inProgressForm} layout="vertical" onFinish={handleInProgressSubmit}>
          <Form.Item name="note" label="Note">
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>Update</Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal title={`Put Task On Hold: ${selectedOnHoldTask?.task_name}`} open={onHoldModalOpen} footer={null} onCancel={() => setOnHoldModalOpen(false)}>
        <Form form={onHoldForm} layout="vertical" onFinish={handleOnHoldSubmit}>
          <Form.Item name="reason" label="Reason" rules={[{ required: true }]}>
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item name="note" label="Note">
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>Update</Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal title={`Add Comment: ${selectedCommentTask?.task_name}`} open={commentModalOpen} footer={null} onCancel={() => setCommentModalOpen(false)}>
        <Form form={commentForm} layout="vertical" onFinish={handleCommentSubmit}>
          <Form.Item name="comment" label="Comment" rules={[{ required: true }]}>
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>Save Comment</Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default AssignedTask;